import {html} from 'lit';

export const facet1Template = (isDefault: boolean) => html`
    <div class="image-facet-1-md">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Ebene_1" x="0px" y="0px" viewBox="0 0 360 270" style="enable-background:new 0 0 360 270;" xml:space="preserve">
            <polygon class="fill-lightblue400" points="295.4,233 360,270 360,195.7 "/>
            <path class="fill-violet500" d="M94.7,73.8l83.3,48.5v96.9l-83.4,48.5l-83.5-48.5v-96.9L94.7,73.8 M94.7,71.5L9.2,121.1v99.2L94.6,270  l85.4-49.7v-99.2L94.7,71.5L94.7,71.5z"/>
        </svg>
    </div>

    <div class="image-facet-1-lg">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Ebene_1" x="0px" y="0px" viewBox="0 0 701 463" xml:space="preserve">
            <path class="fill-yellow" d="M700.8,292.6l-122-69.7v139.8L700.8,292.6z"/>
            <path class="violet-stroke" d="M124.5,149.9l121.2,70.5v141L124.4,432L3,361.4v-141L124.5,149.9 M124.5,147.6L1,219.3v143.3l123.4,71.7
            l123.3-71.7V219.3L124.5,147.6L124.5,147.6z"/>
            <path class="fill-lightblue400-opacity-75" d="M506.2,98.5l0.1,62.5c0,12.9,6.9,24.8,18.1,31.3l54.2,31.3l-0.1-83.3L506.2,98.5z"/>
            <g>
                <path class="fill-blue" d="M578.8,140L476.7,81.1V51.6c0-39.3,42.5-63.9,76.6-44.2l25.5,14.7V140z"/>
            </g>
        </svg>
    </div>

    <div class="image-facet-1__onDark">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Ebene_1" x="0px" y="0px" viewBox="0 0 420 302" xml:space="preserve">
            <g>
                <path class="fill-yellow400-opacity-75" d="M0,174.2l42.3-24.4l42.2,24.4V223l-42.3,24.4L0,223V174.2z"/>
                <path class="fill-lightblue300-opacity-75" d="M356,157.4l0-66.9l-57.7-33.4v67.1L356,157.4z"/>
                <g>
                    <path class="fill-violet" d="M358,94l40.8,23.6l0.2,0.1c11,6.4,17.7,18.2,17.7,30.9v29.9c0,12.7-6.8,24.5-17.7,30.9l-0.2,0.1L358,233.2V94     M356,90.5v146.1l43.8-25.3h0c11.7-6.7,18.9-19.2,18.9-32.8v-29.9c0-13.5-7.2-26-18.9-32.8h0L356,90.5L356,90.5z"/>
                </g>
                <path class="fill-lightblue400" d="M387.7,42.1l-17.3-10c-8.9-5.1-19.9-5.1-28.8,0l-43.3,25L356,90.5l31.7-18.4C399.2,65.5,399.2,48.8,387.7,42.1   z"/>
            </g>
        </svg>
    </div>

    <div class="image-facet-1__onDark--xl">
        ${isDefault ? html`
            <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 430 365" xml:space="preserve">
                <g>
                    <g>
                        <path class="fill-violet" d="M426.8,287.8l0,35.2c0,9.6-5.2,18.6-13.5,23.4l-20,11.6c-4.1,2.4-8.8,3.6-13.5,3.6c-4.7,0-9.4-1.3-13.5-3.6
                        l-0.1,0l0,0l-30.5-17.6L426.8,287.8 M428.8,284.3l-97,56l33.5,19.3l0,0c4.5,2.6,9.5,3.9,14.5,3.9c5,0,10-1.3,14.5-3.9l20-11.6
                        c9-5.2,14.5-14.8,14.5-25.1v0L428.8,284.3L428.8,284.3z"/>
                    </g>
                    <path class="fill-yellow400-opacity-75" d="M1.2,209.5L52.3,180l50.9,29.5v58.9l-51,29.5l-51-29.5V209.5z"/>
                    <path class="fill-lightblue300-opacity-75" d="M428.8,176.6v-67l-58.3-33.7l0.4,67.2L428.8,176.6z"/>
                    <path class="fill-lightblue400" d="M428.8,109.6l-58.3-33.7v-17c0-22.5,24.4-36.5,43.8-25.2l14.6,8.4L428.8,109.6z"/>
                </g>
            </svg>` : html`
            <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 481 481" xml:space="preserve">
                <g>
                    <path class="fill-yellow400-opacity-75" d="M98.8,341.1l49.2-28.4l49,28.4v56.7l-49.1,28.4l-49.1-28.4V341.1z"/>
                    <path class="fill-lightblue400" d="M391.4,162l-58.8-34l0.1-17.4c0.1-22.8,24.6-37,44.2-25.5l14.7,8.6L391.4,162z"/>
                    <g>
                        <path class="fill-violet" d="M393.4,165.5l49.3,28.5l0.1,0l0,0c13.3,7.7,21.5,21.9,21.5,37.3v35.5c0,15.3-8.2,29.6-21.5,37.3l0,0l-0.1,0
                        l-49.3,28.5V165.5 M391.4,162v174.1l52.3-30.2l0,0c14-8,22.6-22.9,22.6-39.1v-35.5c0-16.1-8.6-31-22.6-39.1l0,0L391.4,162
                        L391.4,162z"/>
                    </g>
                    <path class="fill-lightblue300-opacity-75" d="M391.4,229.9V162l-58.8-34V196L391.4,229.9z"/>
                </g>
            </svg>
        `}
    </div>
`;